// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__3BCJz","inputWrap":"Table_inputWrap__31uVR","col":"Table_col__3zKCR","bmiTooltip":"Table_bmiTooltip__1zqFr"};